var getFormulaSku = (function() {
  var leanAndToneFormulaType = 'lean';
  var plantBasedFormulaType = 'plant';
  var weightLossFormulaType = 'weight';
  var cardioFormulaType = 'cardio';

  var optionValidators = {
    isVegan: {
      type: Boolean
    },
    isMilkIntolerant: {
      type: Boolean
    },
    isSoyIntolerant: {
      type: Boolean
    },
    mealType: {
      type: String,
      accepted: ['meal', 'protein']
    },
    flavor: {
      type: String,
      accepted: ['chocolate', 'vanilla']
    },
    gender: {
      type: String,
      accepted: ['male', 'female']
    },
    topGoal: {
      type: String,
      accepted: ['weightLoss', 'maintain', 'gainWeight', 'buildMuscle', 'toneAndSculpt', 'cardioEndurance', 'cardioPerformance', 'performance']
    },
    wantsToLoseOverFifteenLbs: {
      type: Boolean
    },
    loseWeightInTopTwoGoals: {
      type: Boolean
    },
    primaryExerciseIsCardio: {
      type: Boolean
    },
    doesWorkoutOneHundredFiftyMinutes: {
      type: Boolean
    }
  };

  function validate(options) {
    if (typeof options !== 'object') {
      throw new Error('options object is required');
    }

    for (var prop in optionValidators) {
      var validator = optionValidators[prop];
      var validatorType = typeof validator.type();
      var optionVal = options[prop];

      if (options[prop] === undefined) {
        toss(prop, 'the fieldname field is required');
      }

      if (typeof options[prop] !== validatorType) {
        toss(prop, 'expected option fieldname to be a ' + validatorType + ' but received a ' + (typeof optionVal));
      }

      if (validator.accepted && (validator.accepted.indexOf(optionVal) === -1)) {
        toss(prop, 'invalid value ' + optionVal + ' for option fieldname');
      }
    }
  }

  function getUserFormulaType(options) {
    if (options.isVegan || options.isMilkIntolerant || options.isSoyIntolerant) {
      return plantBasedFormulaType;
    }

    if (options.wantsToLoseOverFifteenLbs && options.loseWeightInTopTwoGoals) {
      return weightLossFormulaType;
    }

    switch (options.topGoal) {
      case 'weightLoss':
        return getWeightLossGoalFormulaType();
      case 'cardioEndurance':
        return getCardioEnduranceGoalFormulaType(options.doesWorkoutOneHundredFiftyMinutes);
      case 'toneAndSculpt':
        return getToneAndSculptGoalFormulaType(options.doesWorkoutOneHundredFiftyMinutes, options.primaryExerciseIsCardio);
      case 'maintain':
        return getMaintainGoalFormulaType(options.doesWorkoutOneHundredFiftyMinutes, options.primaryExerciseIsCardio);
      case 'cardioPerformance':
      case 'performance':
        return getPerformanceGoalFormulaType(options.doesWorkoutOneHundredFiftyMinutes, options.primaryExerciseIsCardio);
      case 'buildMuscle':
      case 'gainWeight':
        return getBuildMuscleGoalFormulaType(options);
    }
  }

  function getWeightLossGoalFormulaType() {
    return weightLossFormulaType;
  }

  function getCardioEnduranceGoalFormulaType(doesWorkoutOneHundredFiftyMinutes) {
    return doesWorkoutOneHundredFiftyMinutes ? cardioFormulaType : weightLossFormulaType;
  }

  function getToneAndSculptGoalFormulaType(doesWorkoutOneHundredFiftyMinutes, primaryExerciseIsCardio) {
    if (primaryExerciseIsCardio) {
      return doesWorkoutOneHundredFiftyMinutes ? cardioFormulaType : leanAndToneFormulaType;
    }
    return doesWorkoutOneHundredFiftyMinutes ? leanAndToneFormulaType : weightLossFormulaType;
  }

  function getMaintainGoalFormulaType(doesWorkoutOneHundredFiftyMinutes, primaryExerciseIsCardio) {
    if (primaryExerciseIsCardio) {
      return doesWorkoutOneHundredFiftyMinutes ? cardioFormulaType : leanAndToneFormulaType;
    }
    return doesWorkoutOneHundredFiftyMinutes ? leanAndToneFormulaType : weightLossFormulaType;
  }

  function getPerformanceGoalFormulaType(doesWorkoutOneHundredFiftyMinutes, primaryExerciseIsCardio) {
    if (primaryExerciseIsCardio) {
      return doesWorkoutOneHundredFiftyMinutes ? cardioFormulaType : weightLossFormulaType;
    }
    return doesWorkoutOneHundredFiftyMinutes ? leanAndToneFormulaType : weightLossFormulaType;
  }

  function getBuildMuscleGoalFormulaType() {
    return leanAndToneFormulaType;
  }

  function toss(field, message) {
    var e = new Error(message.replace(/\bfieldname\b/ig, field));
    e.field = field;
    throw e;
  }

  function getSku(options) {
    validate(options);
    var formulaType = getUserFormulaType(options);
    return 'IFN' + options.mealType[0].toUpperCase() + formulaType[0].toUpperCase() + options.gender[0].toUpperCase() + options.flavor[0].toUpperCase();
  }

  // public api
  return getSku;
})();

// If we're in Node
if (typeof exports !== 'undefined') {
  exports.getFormulaSku = getFormulaSku;
}
